module.exports = __webpack_public_path__ + "img/delete.02feb2f3.svg";